import { UserIcon } from '../../../assets/Icons';
import type { Customer } from '../../../types/codexOrder';
import { formatPhoneNumber } from '../../../helpers/utils';

function OrderCustomer({ customer }: { customer: Customer | undefined }) {
  if (!customer) {
    return null;
  }

  return (
    <div className="p-4 rounded-lg bg-white mb-4">
      <div className="flex items-center gap-x-2 mb-3">
        <UserIcon className="text-brand-icon" />
        <p className="font-bold">{customer?.name}</p>
      </div>
      {customer?.phone && (
        <p className="text-up-black-50 text-sm" style={{ wordSpacing: 4 }}>
          {formatPhoneNumber(customer?.phone)}
        </p>
      )}
    </div>
  );
}

export default OrderCustomer;
